/*
 * Chip (tag, badge), ported from the Tixora template's HeroUI chip: a soft tint of its tone
 * with the tone as ink, or solid. Styles in styles/data-display.css.
 */
type ChipProps = {
    className?: string;
    tone?: "accent" | "success" | "warning" | "danger" | "default";
    variant?: "soft" | "solid";
    size?: "sm" | "md" | "lg";
    /** Draws the eye once when the chip mounts with a changed state (motion-pulse-once). */
    pulse?: boolean;
    children: React.ReactNode;
};

const Chip = ({ className, tone = "default", variant = "soft", size = "sm", pulse, children }: ChipProps) => (
    <span
        className={`chip chip--${tone} chip--${variant} ${size === "md" ? "" : `chip--${size}`} ${pulse ? "motion-pulse-once" : ""} ${className || ""}`}
    >
        <span className="chip__label">{children}</span>
    </span>
);

export default Chip;
